module.exports = __webpack_public_path__ + "static/media/1012210.a700affa.png";